import React, { useCallback, useState } from 'react';
import config from 'config';
import PropTypes from 'prop-types';
import InlineDateUpdate from 'components/InlineDateUpdate';
import { updateCarrier as updateCarrierAction } from 'actions/carriers';
import { useDispatch } from 'react-redux';

const t = {
  preferredLanguage: 'Preferred language:',
  status: 'Status:',
  company_creation_date: 'Company creation date:',
};

const DocsCarrierInfo = ({ className, carrier }) => {
  const dispatch = useDispatch();
  const [currentCompanyCreationDate, setCurrentCompanyCreationDate] = useState(
    carrier.company_creation_date
  );

  const handleCarrierClick = useCallback(() => {
    window.open(`${config.BASE_ROUTE}carrier/${carrier?.id}`);
  }, [carrier]);

  const handleDateUpdate = useCallback(
    async (date) => {
      try {
        const updatedCarrier = await dispatch(
          updateCarrierAction({ id: carrier?.id, company_creation_date: date })
        );
        setCurrentCompanyCreationDate(updatedCarrier.company_creation_date);
      } catch (err) {
        console.error('Error updateCarrierAction date', err);
      }
    },
    [carrier, dispatch]
  );

  return (
    <div className={className} data-testid="docs-carrier-info">
      <div className="docs-carrier-info">
        <h1 className="docs-carrier-info__title" onClick={handleCarrierClick}>
          {carrier.name}
        </h1>
        <div className="docs-carrier-info__body">
          <div className="docs-carrier-info__section">
            <div className="docs-carrier-info__label">{carrier.tax_number}</div>
            <div className="docs-carrier-info__label">{carrier.iban}</div>
            <div className="docs-carrier-info__label">
              {t.preferredLanguage} {carrier.locale}
            </div>
            <div className="docs-carrier-info__label">
              {t.status} {carrier.status}
            </div>
          </div>
          <div className="docs-carrier-info__section">
            <div className="docs-carrier-info__label">{carrier.billing_address.address_line}</div>
            <div className="docs-carrier-info__label">{carrier.billing_address.zipcode}</div>
            <div className="docs-carrier-info__label">{`${carrier.billing_address.city} ${carrier.country}`}</div>
            <div className="docs-carrier-info__label docs-carrier-info__label--inline">
              <span className="docs-carrier-info__label">{t.company_creation_date}</span>
              <span className="docs-carrier-info__label--button">
                <InlineDateUpdate
                  currentDate={currentCompanyCreationDate}
                  handleSave={handleDateUpdate}
                />
              </span>
            </div>
          </div>
          <div className="docs-carrier-info__section">
            <div className="docs-carrier-info__label">{carrier.contact_name}</div>
            <div className="docs-carrier-info__label">{carrier.phone}</div>
            <div className="docs-carrier-info__label">{carrier.email}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

DocsCarrierInfo.defaultProps = {
  className: '',
};

DocsCarrierInfo.propTypes = {
  className: PropTypes.string,
  carrier: PropTypes.object.isRequired,
};

export default DocsCarrierInfo;
